import React from "react";
import { Box, Button, Typography } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getStatusCatalogue } from "../../api/common/catalogues.ts";
import { Form, Formik } from "formik";
import { useSnack } from "../../services/SnakbarProvider.js";

interface StatusManagerProps {
  props: any;
  updateFunction: any;
  catalogueName: string;
  fieldName: string;
}

const StatusManager: React.FC<StatusManagerProps> = ({ props = "", updateFunction, catalogueName, fieldName = "statusId" }) => {
  const { id, onSubmit } = props;
  const { openSnack } = useSnack();

  const handleSubmit = async (values) => {
    try {
      const response = await updateFunction(id, { [fieldName]: values[fieldName] });      
      openSnack("Estado actualizado correctamente", "success");
      onSubmit();
    } catch (error) {
      openSnack("Error al actualizar el estado", "error");
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Formik
        initialValues={{ [fieldName]: "" }}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form >
            <DropdownSelector
              name={fieldName}
              label="Nuevo Estado"
              fetchFunction={getStatusCatalogue}
              fetchParams={catalogueName}
              optionLabel="name"
            />

            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{ mt: 2 }}
            >
              Cambiar Estado
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default StatusManager;
